import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import classes from "./ShowDetail.module.css";
import commonStyles from "src/assets/global_styles/commom.module.css";
import { TvSeriesInfo } from "src/types/tvSeriesDetail";

import Loader from "src/shared/Loader";
import { dateFormat } from "src/utility";
import { getShowDetail } from "src/shared/api";

const ShowDetail = () => {
  const [data, setData] = useState<TvSeriesInfo | null>(null);
  let { id } = useParams();

  useEffect(() => {
    getShowDetail(id).then((response) => setData(response.data));
  }, [id]);

  if (!data) {
    return <Loader />;
  }

  return (
    <main className={classes.container}>
      <section className={classes.topSection}>
        <img
          className={classes.showImage}
          alt="movie poster"
          src={`https://image.tmdb.org/t/p/w500${data.poster_path}`}
          height={400}
        />
        <div>
          <h1 className={classes.title}>{data.name}</h1>
          <p className={classes.tagLine}>{data.tagline}</p>
          <div className={classes.infoBox}>
            <span className={classes.status}>
              <span className={commonStyles.bold}>Status:</span> {data.status}
            </span>
            <span className={classes.genre}>
              <span className={commonStyles.bold}>Genre: </span>
              {data.genres.map((genre, index) => (
                <li className={classes.genreListItems}>
                  {genre.name}
                  {index < data.genres.length - 1 && ","}
                </li>
              ))}
            </span>
            <span>
              <span className={commonStyles.bold}>First air date: </span>
              {dateFormat(data.first_air_date)}
            </span>
            <span>
              <span className={commonStyles.bold}>Last air date:</span>
              {dateFormat(data.last_air_date)}
            </span>
            <span>
              <span className={commonStyles.bold}>Total seasons:</span>
              {data.number_of_seasons}
            </span>
            <span>
              <span className={commonStyles.bold}>Total episodes:</span>
              {data.number_of_episodes}
            </span>
            <span className={classes.creator}>
              <span className={commonStyles.bold}>Created by: </span>
              {data.created_by.map((item, index) => (
                <li className={classes.creatorListItems}>
                  {item.name}
                  {index < data.created_by.length - 1 && ","}
                </li>
              ))}
            </span>
          </div>
        </div>
      </section>
      <p className={classes.seasonStoryLine}>{data.overview}</p>
      <section className={classes.seasonsList}>
        {data.seasons.map((season) => (
          <Link to={`seasons/${season.season_number}`}>
            <button className={classes.seasonButton}>{season.name}</button>
          </Link>
        ))}
      </section>
    </main>
  );
};

export default ShowDetail;
